/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Step_PurchaseInputs */

const en_premium_step_purchase = /** @type {(inputs: Premium_Step_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase`)
};

const es_premium_step_purchase = /** @type {(inputs: Premium_Step_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compra`)
};

/**
* | output |
* | --- |
* | "Purchase" |
*
* @param {Premium_Step_PurchaseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_step_purchase = /** @type {((inputs?: Premium_Step_PurchaseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Step_PurchaseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_step_purchase(inputs)
	return en_premium_step_purchase(inputs)
});